<template>
  <section class="pa-2">
    <v-card class="p-1">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Deposit Channel</div>
        <div>
          <bread-crumb :bread-crumbs="['Deposit Channel']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-title>
        <v-row class="ms-1 mt-1">
          <v-btn
            depressed
            small
            color="primary"
            class="text-capitalize me-3 text-decoration-none"
            to="/createDepositchannel"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>Add Deposit
            Channel</v-btn
          >
          <v-btn depressed @click="downloadExcelsheet" color="primary" small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
        </v-row>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        dense
        :search="search"
        class="mt-2"
        :items="DepositeChannel"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small color="primary" class="mr-2" @click="
          $router.push({
            name: 'Create Deposit Channel',
            query: { id: item.channel_id },
          })
        ">
        mdi-content-save-edit-outline
          </v-icon>
          <v-icon small color="primary" @click="deleteItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <!-- delete dialog -->
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed  small color="primary" outlined @click="deleteItemConfirm">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed 
            small
            color="primary"
            outlined
            @click="(dialogDelete = false), (deleteId = null)"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OverlayPageVue :showOverlay="loader" />
  </section>
</template>
<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import setupService from "@/services/SetupService/setupService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Deposit Channel",
  mixins: [alerts],
  data: () => {
    return {
      loader: false,
      id: null,
      dialogDelete: false,
      search: "",
      headers: [
        {
          text: "Id",
          value: "channel_id",
          sortable: false 
        },
        { text: "Channel Name", value: "name" , sortable: false },
        { text: "External Link", value: "external_id" , sortable: false },
        { text: "Mapped Ledger ID", value: "ledger_id", sortable: false  },
        { text: "Channel Type", value: "channel_type", sortable: false  },
        { text: "Account No", value: "account_number", sortable: false  },
        { text: "Account Name", value: "account_name", sortable: false  },
        { text: "Account Name Other", value: "account_other_name", sortable: false  },
        // { text: "Deposit Type", value: "account_type", sortable: false  },
        { text: "Actions", value: "actions", sortable: false },
      ],
      DepositeChannel: [],
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted(){
    this.getAllChannelData();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.DepositeChannel) {
        this.exportToExcel(
          this.headers,
          this.DepositeChannel,
          "Deposite chennel"
        );
      }
    },
    async getAllChannelData(){
      this.loader = true;
      try {
        const response = await setupService.getALlDepositeChannel();
        if (response.status === 200) {
          this.DepositeChannel = response.data.data;
          this.stoploader();
        }
        console.log("countryOptions", this.DepositeChannel);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.DepositeChannel = [];
      }
    },

    deleteItem(item){
      this.dialogDelete = true;
      this.deleteId = item.channel_id;
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        setTimeout(() => {
          this.loader = false;
        }, 400);
        const responseData = await setupService.deleteDepositeChannel(this.deleteId);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllChannelData();
          this.dialogDelete = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
      }

    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
